import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreateContentMutation } from "../graphql/mutations";
import type {
  CreateContentMutationType,
  CreateContentMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreateContentMutation = (
  options?: MutationHookOptions<
    CreateContentMutationType,
    CreateContentMutationVariablesType
  >
) => {
  return useMutation<
    CreateContentMutationType,
    CreateContentMutationVariablesType
  >(CreateContentMutation, options);
};
